module.exports = {
    screen1: null,
    app:null,
    user:null,
 };